export default "__VITE_ASSET__b95c95e1__"